import React from "react";

const ReportsBonuses = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header" className="no-print">
                    <h1>Бонуси</h1>
                </div>
                <div className="row">
                    <div className="col-12">
                        <form method="post" action="" className="no-print">
                            <div className="card card-default">
                                <div className="card-header">Параметри</div>
                                <div className="card-body datas">
                                    <div className="row">
                                        <div className="col-12 col-sm-6 col-md-3">
                                            <select name="store_id" className="form-select mb-3"></select>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3">
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Від</span>
                                                <input
                                                    type="text"
                                                    name="date_from"
                                                    className="datepicker form-control"
                                                    value="03.03.2023"
                                                    data-date-format="dd.mm.yyyy"
                                                    aria-describedby="date_from"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3">
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">До</span>
                                                <input
                                                    type="text"
                                                    name="date_to"
                                                    className="datepicker form-control"
                                                    value="03.03.2023"
                                                    data-date-format="dd.mm.yyyy"
                                                    aria-describedby="date_to"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-3">
                                            <button
                                                type="submit"
                                                name="go_report"
                                                value="Порахувати бонуси"
                                                className="btn btn-primary"
                                            >
                                                Порахувати бонуси
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="alert alert-warning margin20">Виберіть магазин</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportsBonuses;
